//--------------------------------------MUI--------------------------------//
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Tooltip,
  Stack,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Autocomplete from "@mui/material/Autocomplete";

//--------------------ICONS--------------------//
import {
  AccountCircle,
  Add,
  AddAlarm,
  AddBox,
  ArrowBackIos,
  CheckCircle,
  CloudDownload,
  ExpandMore,
  NoteAdd,
  OfflinePin,
  PauseCircleFilled,
  People,
  PersonAdd,
  PlayCircleFilledWhite,
  RepeatOutlined,
  Save,
  Timelapse,
  Assignment,
  CloudUpload,
} from "@mui/icons-material";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import RecordVoiceOver from "@mui/icons-material/RecordVoiceOver";

//-----------------------------------THIRD-PARTY-------------------------------------------//
import "moment/locale/tr";
import "react-toastify/dist/ReactToastify.css";
import { useSnackbar } from "notistack";
import * as queryString from "query-string";
import moment from "moment";

//-------------------------------REACT-REDUX----------------------------------------------//
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

//-------------------------------ACTIONS----------------------------------------------//
import {
  getTaskDetailById,
  getEkedEquipmentList,
  updateEkedEquipmentList,
  getBreakdownPoolList,
  addUnPlannedMaintenanceOfTheReport,
  getUnPlannedMaintenanceOfTheReport,
  deleteUnPlannedMaintenanceOfTheReports,
  addTechnician,
  createSubTask,
  assignTask,
  getBreakdownReasonPlaceListByGroupIdAndPoolRelations,
  getBreakdownReasonListWithPoolRelations,
  getSameLevelListById,
  getBreakdownRootCauseList,
  getMaintenancePauseReasonList,
  getListByStatusUnPlannedMaintenance,
  getCurrentUsersActiveTaskId,
  getTaskHistoryByIdUnPlannedMaintenance,
  addUnplannedFiles,
  getUnplannedFiles,
  getBreakdownReasonDetailListByPlaceId,
  updateUnPlannedMaintenance,
  pauseUnPlannedMaintenance,
  completeUnPlannedMaintenance,
  closeUnPlannedMaintenance,
  getTechnicianList,
  playUnPlannedMaintenance,
  startUnPlannedMaintenance,
  deleteUnplannedFiles,
  reopenUnplannedMaintenance,
} from "../../store/actions/breakDownDetailActions";
import { getCheckTaskHasEwoForm } from "../../store/actions/EwoActions";
import { getEquipmentFiles, deleteEquipmentFiles } from "../../store/actions/EquipmentAction";
import { deleteTechnicianFromUnplanned } from "../../store/actions/CustomListActions";
import { getSparePartList } from "../../store/actions/SparePartActions";
import { getOperatorFieldsByTaskId } from "../../store/actions/EwoActions";

//-------------------------------COMPONENTS----------------------------------------------//
import SecurityPopup from "../../components/Popup/SecurityPopup";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import DocumentPopup from "../../components/Popup/DocumentPopup";
import TimelinePopup from "../../components/Popup/TimelinePopup";
import UnplannedMaintenaceOfTheReportsPopup from "../../components/Popup/UnplannedMaintenaceOfTheReportsPopup";
import RequestCard from "../../components/RequestCard/RequestCard";

import { handleBackendMessage, renderToaster, getSelectedFileNames, getFormDataFromFiles } from "../../common";
import { set } from "lodash";
import { getEwoFormDetailById } from "../../api/EwoApi";

//#region style
const useStyles = makeStyles((theme) => ({
  colorized: {
    width: 20,
    height: 20,
  },
  speedDial: {
    position: "absolute",
    bottom: theme.spacing(7), // 8*7 pixels spaces from bottom.
  },
  backdrop: {
    zIndex: 1,
    color: "#fff",
  },
  iconButtonLabel: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    width: "70px",
    margin: "auto",
  },
  orderFormButtonStyle: {
    width: 58,
    height: 60,
    padding: 0,
    "&:hover": {
      transition: "0.5s",
      color: "#23B8B8",
    },
  },
  timeLapseButtonStyle: {
    width: 58,
    height: 60,
    padding: 0,
    "&:hover": {
      transition: "0.5s",
      color: "#E55B1F",
    },
  },
  downloadDocButtonStyle: {
    width: 58,
    height: 60,
    padding: 0,
    "&:hover": {
      transition: "0.5s",
      color: "#39A915",
    },
  },
  uploadDocButtonStyle: {
    width: 58,
    height: 60,
    padding: 0,
    "&:hover": {
      transition: "0.5s",
      color: "#0BBFC4",
    },
  },
}));

const iconButtonStyle = {
  width: 58,
  height: 60,
  padding: 0,
  "&:hover": {
    color: "#23B835",
  },
};

const useStylesTooltip = makeStyles((theme) => ({
  staticTooltipLabel: {
    fontSize: 13,
    fontWeight: "bold",
    width: 160,
  },
}));
//#endregion

const PDM_USER_CODE = "MostSrvUser";

export default function BreakdownDetail(props) {
  const classes = useStyles();
  const classTooltip = useStylesTooltip();
  const [assigneeID, setAssigneeID] = useState();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [taskClosed, setTaskClosed] = useState(false);
  const [userID, setUserID] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation("translation");
  

  const dispatch = useDispatch();

  useEffect(() => {
    const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
    setUserID(oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", ""));
    LoadHandler();
    HasUserActiveTask();
  }, []);

  const [rows, setRows] = useState([]);
  const [breakdownRootCause, setBreakdownRootCause] = useState([]);
  const [equipmentInfo, setEquipmentInfo] = useState([]);
  const [editedEquipment, setEditedEquipment] = useState();
  const [securityDialogOpen, setSecurityDialogOpen] = useState(false);
  const [selectedEkedEquipmentIds, setSelectedEkedEquipmentIds] = useState([]);
  const [tempEkedEquipmentIds, setTempEkedEquipmentIds] = useState([]);
  const [selectedEkedEquipmentNames, setSelectedEkedEquipmentNames] = useState([]);
  const [tempEkedEquipmentNames, setTempEkedEquipmentNames] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [ekedUsed, setEkedUsed] = useState(false);
  const [disabledEked, setDisabledEked] = useState(false);
  const [startPayload, setStartPayload] = useState(null);
  const [breakdownDetailErrorStatus, setBreakdownDetailErrorStatus] = useState(false);
  const [breakdownDetailErrorText, setBreakdownDetailErrorText] = useState("");
  const [rootCauseErrorStatus, setRootCauseErrorStatus] = useState(false);
  const [rootCauseErrorText, setRootCauseErrorText] = useState("");
  const [noteErrorStatus, setNoteErrorStatus] = useState();
  const [noteErrorText, setNoteErrorText] = useState("");
  const [orderNote, setOrderNote] = useState("");
  const [isEnvNotClean, setIsEnvNotClean] = useState(false);
  const [UnplannedMaintenanceOfTheReport, setUnplannedMaintenanceOfTheReport] = useState([]);
  const [currentUsersActiveTaskId, setCurrentUsersActiveTaskId] = useState(null);
  const [isUserAssignee, setIsUserAssignee] = useState(false);
  const [activeUsersTaskPopup, setActiveUsersTaskPopup] = useState(false);
  const [hasSparePart, setHasSparePart] = useState(false);
  const [userIList, setUserIList] = useState([]);
  const [emptyEwoForm, setEmptyEwoForm] = useState(true);
  const [completedEwoForm, setCompletedEwoForm] = useState(false);
  const [isEditableForm, setIsEditableForm] = useState(false);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [isDisableAddEwoButton, setIsDisableAddEwoButton] = useState(true);
  const [ewoCode, setEwoCode] = useState("");

  let history = useHistory();

  const LoadHandler = () => {
    const id = queryString.parse(window.location.search).id;
    
    // Clear sessionStorage entries when loading a new breakdown
    sessionStorage.removeItem("notes");
    sessionStorage.removeItem("selectedBreakdownReasonPlace");
    sessionStorage.removeItem("selectedBreakdownReasonDetailName");
    sessionStorage.removeItem("selectedBreakdownRootCauseName");
    sessionStorage.removeItem("selectedBreakdownReasonGroupFilter");
    
    dispatch(getTaskDetailById(id));
    dispatch(getCurrentUsersActiveTaskId());
    if (id != undefined || id != null) {
      dispatch(getOperatorFieldsByTaskId(id));
    }
    dispatch(getCheckTaskHasEwoForm(id));

    fetchSparePart();
  };
  const { breakDownDetail } = useSelector((state) => state);
  const { equipment } = useSelector((state) => state);
  const { ewoForm } = useSelector((state) => state);
  const { sparePartList } = useSelector(({ SparePart }) => SparePart);
  const {
    user: { userInterfaceList },
  } = useSelector((user) => user);

  useEffect(() => {
    if (userInterfaceList?.resultObject) {
      let interfaceList = userInterfaceList?.resultObject?.interfaceList;
      setUserIList(interfaceList);
    }
  }, [userInterfaceList]);

  useEffect(() => {
    if (ewoForm.checkHasEwoFormObject.success) {
      setCompletedEwoForm(true);
      setEwoCode(ewoForm.checkHasEwoFormObject.ewoCode);
    } else {
      setCompletedEwoForm(false);
    }
  }, [ewoForm.checkHasEwoFormObject]);

  useEffect(() => {
    if (ewoForm.checkHasEwoFormObject.success) {
      setCompletedEwoForm(true);
      setEwoCode(ewoForm.checkHasEwoFormObject.ewoCode);
    } else {
      setCompletedEwoForm(false);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(ewoForm?.ewoFormDetailById).length !== 0) {
      setIsEditableForm(true);
    }
  }, []);
  useEffect(() => {
    if (!ewoForm.ewoFormOperatorFields.success) {
      setEmptyEwoForm(true);
    } else {
      setEmptyEwoForm(false);
    }
  }, [ewoForm.ewoFormOperatorFields]);

  const [breakdownDetailName, setBreakdownDetail] = useState(null);

  const taskId = queryString.parse(window.location.search).id;

  useEffect(() => {
    const place = sessionStorage.getItem("selectedBreakdownReasonPlace");
    const detail = sessionStorage.getItem("selectedBreakdownReasonDetailName");
    if (place && detail) {
      setBreakdownDetail(place + " - " + detail);
      setBreakdownDetailErrorStatus(false);
      setBreakdownDetailErrorText("");
    }
  }, [taskId]);

  // Component Mount Response
  useEffect(() => {
    if (breakDownDetail?.taskDetail?.resultObject) {
      GenericLoadRows(breakDownDetail.taskDetail.resultObject);
      const { equipmentId } = breakDownDetail.taskDetail.resultObject;
      setAssigneeID(breakDownDetail.taskDetail.resultObject.assigneeCode);
      setIsChecked(breakDownDetail.taskDetail.resultObject.isEkedUsed);
      setEkedUsed(breakDownDetail.taskDetail.resultObject.isEkedUsed);
      setIsEnvNotClean(breakDownDetail.taskDetail.resultObject.isEnvNotClean);
      if (breakDownDetail.taskDetail.resultObject.isEkedUsed) {
        const id = queryString.parse(window.location.search).id;
        dispatch(getEkedEquipmentList(id));
      }
      if (
        breakDownDetail.taskDetail.resultObject.taskStatus === 3 &&
        breakDownDetail.taskDetail.resultObject.breakdownRootCauseName === null
      ) {
        if (!breakdownDetailName) {
          setBreakdownDetailErrorStatus(true);
          setBreakdownDetailErrorText(t("EmptyCheck"));
        }
        setRootCauseErrorStatus(true);
        setRootCauseErrorText(t("EmptyCheck"));

        if (breakDownDetail.taskDetail.resultObject.orderNote && notes === null) {
          setOrderNote(null);
          setNoteErrorStatus(true);
          setNoteErrorText(t("EmptyCheck"));
        }
      }
      if (
        breakDownDetail.taskDetail.resultObject.taskStatus === 3 ||
        breakDownDetail.taskDetail.resultObject.taskStatus === 5
      ) {
        dispatch(getUnPlannedMaintenanceOfTheReport(breakDownDetail.taskDetail.resultObject.id));
      }
      if (breakDownDetail.taskDetail.resultObject.taskStatus === 6 && taskClosed) {
        props.history.goBack();
        setTaskClosed(false);
      }
      if (breakDownDetail.taskDetail.resultObject.taskStatus === 6 && !taskClosed) {
        setDisableEquipment(true);
        dispatch(getBreakdownRootCauseList());
      }
      if (breakDownDetail.taskDetail.resultObject.taskStatus !== 6) {
        dispatch(getSameLevelListById(equipmentId));
      }
    }
  }, [breakDownDetail.taskDetail]);

  useEffect(() => {
    setDisableFinishButtonValidation(rootCauseErrorStatus || breakdownDetailErrorStatus || noteErrorStatus);
    setDisableFinishButton(rootCauseErrorStatus || breakdownDetailErrorStatus || noteErrorStatus);
  }, [rootCauseErrorStatus, breakdownDetailErrorStatus, noteErrorStatus]);

  useEffect(() => {
    if (breakDownDetail?.taskEkedList?.resultObject && isChecked) {
      setSelectedEkedEquipmentIds(breakDownDetail.taskEkedList.resultObject.map((item) => item.ekedEquipmentId));
      setTempEkedEquipmentIds(breakDownDetail.taskEkedList.resultObject.map((item) => item.ekedEquipmentId));
    }
  }, [breakDownDetail.taskEkedList]);

  useEffect(() => {
    if (breakDownDetail?.sameLevelList?.resultObject) {
      setEquipmentInfo(Object.values(breakDownDetail.sameLevelList.resultObject));
    }
  }, [breakDownDetail.sameLevelList]);

  useEffect(() => {
    if (breakDownDetail?.rootCauses?.resultObject) {
      setBreakdownRootCause(Object.values(breakDownDetail.rootCauses.resultObject));
      setPageLoaded(true);
    }
  }, [breakDownDetail.rootCauses]);

  // ------***---

  useEffect(() => {
    if (breakDownDetail?.technicians) {
      setUserData(Object.values(breakDownDetail.technicians.resultObject));
      LoadAddFriendUserData(
        breakDownDetail.technicians.rows,
        Object.values(breakDownDetail.technicians.resultObject),
        breakDownDetail.technicians.rows.techList
      );
      setAssigneeID(breakDownDetail.technicians.rows.assigneeCode);
    }
  }, [breakDownDetail.technicians]);

  // Load Edit Req

  useEffect(() => {
    if (breakDownDetail?.bdPoolList?.createSubTask) {
      setPoolData(breakDownDetail.bdPoolList.resultObject);
      setOpenSubtaskPopup(true);
    }
    if (breakDownDetail?.bdPoolList?.editRequest) {
      setPoolData(breakDownDetail.bdPoolList.resultObject);
    }
  }, [breakDownDetail.bdPoolList]);

  useEffect(() => {
    if (breakDownDetail?.bdReasonList?.editRequest) {
      setBreakDownReasonGroupData(breakDownDetail.bdReasonList.resultObject);
    }
  }, [breakDownDetail.bdReasonList]);

  useEffect(() => {
    if (breakDownDetail?.bdReasonGroupList?.resultObject) {
      setBreakdownReasonGroupDataFilter(breakDownDetail.bdReasonGroupList.resultObject);
    }
  }, [breakDownDetail.bdReasonGroupList]);

  useEffect(() => {
    if (breakDownDetail?.bdEffectList?.resultObject) {
      setBreakdownEffectData(breakDownDetail.bdEffectList.resultObject);
      setEditRequestPopup(true);
    }
  }, [breakDownDetail.bdEffectList]);

  // ----**--

  useEffect(() => {
    if (breakDownDetail?.reasonPlaces?.resultObject) {
      setBreakdownReasonPlace(breakDownDetail.reasonPlaces.resultObject);
    }
  }, [breakDownDetail.reasonPlaces]);

  // Create SubTask
  useEffect(() => {
    if (breakDownDetail?.subtaskUnPM?.resultObject) {
      setSubtaskPool(null);
      setSubTaskNote("");
    }
  }, [breakDownDetail.subtaskUnPM]);

  useEffect(() => {
    if (
      breakDownDetail?.activeUsersTaskId?.resultObject !== null &&
      breakDownDetail?.activeUsersTaskId?.resultObject !== undefined &&
      breakDownDetail?.activeUsersTaskId?.resultObject.taskId !== 0
    ) {
      const activeUsersTaskId = breakDownDetail.activeUsersTaskId.resultObject.taskId;
      setCurrentUsersActiveTaskId(activeUsersTaskId);
      setIsUserAssignee(breakDownDetail.activeUsersTaskId.resultObject.isUserAssignee);
      if (activeUsersTaskId != queryString.parse(window.location.search).id) {
        setActiveUsersTaskPopup(true);
      }
    }
  }, [breakDownDetail.activeUsersTaskId]);

  // Start Task
  useEffect(() => {
    // if (breakDownDetail?.setListByStatusUnPM?.UserActiveTask) {
    //     var assignedUserTasks = breakDownDetail.setListByStatusUnPM.resultObject.filter((item) => item.assigneeCode == userID); //fetch active task
    //     if (assignedUserTasks.length > 0 && assignedUserTasks[0].id != queryString.parse(window.location.search).id) {
    //         setToastMessage(assignedUserTasks);
    //     }
    // }
    // if (breakDownDetail?.setListByStatusUnPM?.goToStartedTask) {
    //     var assignedUserTasks = breakDownDetail.setListByStatusUnPM.resultObject.filter((item) => item.assigneeCode == userID); //fetch active task

    //     if (assignedUserTasks.length > 0) {
    //         history.push("breakdowndetail?id=" + assignedUserTasks[0].id); //go to active task if user has.
    //         window.location.reload();
    //     }
    // }
    if (breakDownDetail?.setListByStatusUnPM?.startTask) {
      const { rowData } = breakDownDetail.setListByStatusUnPM;

      var assignedUserTasks = breakDownDetail.setListByStatusUnPM.resultObject.filter(
        (item) => item.assigneeCode == rowData.assigneeCode
      ); //fetch assigned tasks
      var techList = [];
      if (typeof (rowData.techList === "undefined")) {
        // Temp code add up to byPass techList "undefined"
        rowData["techList"] = [];
      }
      if (rowData.techList.length > 0) {
        for (var i = 0; i < rowData.techList.length; i++) {
          var techListTasks = breakDownDetail?.setListByStatusUnPM.resultObject.filter(
            (item) => item.assigneeCode == rowData.techList[i].userCode
          ); //fetch each tech's tasks.
          if (techListTasks.length > 0) {
            //add to list if technician has started task
            for (var j = 0; j < techListTasks.length; j++) {
              techList.push(techListTasks[j]);
            }
          }
        }
      }

      var currentUserTasks = techList.filter((item) => item.assigneeCode == userID); //started tasks of current user.

      if (assignedUserTasks.length == 0 && currentUserTasks.length == 0) {
        //continue task
        if (rowData.taskStatus === 4) {
          dispatch(playUnPlannedMaintenance(rowData.id));
        }
        //start task
        else {
          dispatch(startUnPlannedMaintenance(rowData.id));
        }
      }
    }
  }, [breakDownDetail.setListByStatusUnPM]);

  //Pause Task

  useEffect(() => {
    if (breakDownDetail?.maintenancePauseReasons?.resultObject) {
      setMaintenancePauseReasonData(Object.values(breakDownDetail.maintenancePauseReasons.resultObject));
      setPausePopup(true);
    }
  }, [breakDownDetail.maintenancePauseReasons]);

  useEffect(() => {
    if (breakDownDetail?.taskHistory?.resultObject) {
      setTimelineArray(Object.values(breakDownDetail.taskHistory.resultObject));
    }
  }, [breakDownDetail.taskHistory]);

  useEffect(() => {
    if (breakDownDetail?.unplannedFiles) {
      setDocumentList(breakDownDetail.unplannedFiles);
      breakDownDetail.unplannedFiles = null;
    }
  }, [breakDownDetail.unplannedFiles]);

  useEffect(() => {
    if (breakDownDetail?.setBDReasonDetailList?.resultObject) {
      setBreakdownReasonDetail(breakDownDetail.setBDReasonDetailList.resultObject);
      if (breakDownDetail.setBDReasonDetailList.resultObject.length == 1) {
        setSelectedBreakdownReasonDetailCode(breakDownDetail.setBDReasonDetailList.resultObject[0].id);
        setSelectedBreakdownReasonDetailName(breakDownDetail.setBDReasonDetailList.resultObject[0].name);
      }
    }
  }, [breakDownDetail.setBDReasonDetailList]);

  useEffect(() => {
    if (breakDownDetail?.isTaskUpdated) {
      setTaskClosed(true);
      LoadHandler();
    }
  }, [breakDownDetail.isTaskUpdated]);

  // Get Equipment Files
  useEffect(() => {
    if (equipment?.equipmentFiles) {
      setEquipmentFiles(equipment.equipmentFiles);
      setDocumentPopup(true);
      equipment.equipmentFiles = null;
    }
  }, [equipment]);

  useEffect(() => {
    if (breakDownDetail?.unplannedMaintenaceOfTheReports?.resultObject) {
      setUnplannedMaintenanceOfTheReport(breakDownDetail.unplannedMaintenaceOfTheReports.resultObject);
    }
  }, [breakDownDetail.unplannedMaintenaceOfTheReports]);

  useEffect(() => {
    if (breakDownDetail?.isDeletedReports) {
      dispatch(getUnPlannedMaintenanceOfTheReport(queryString.parse(window.location.search).id));
    }
  }, [breakDownDetail.isDeletedReports]);

  useEffect(() => {
    if (sparePartList?.resultObject?.totalCount > 0) {
      setHasSparePart(true);
    }
  }, [sparePartList]);

  const fetchSparePart = () => {
    let payload = {
      currentPage: 1,
      pageSize: 10,
      searchText: "",
      propertyName: "",
      direction: 1,
    };
    dispatch(getSparePartList(payload));
  };

  const GenericLoadRows = (result) => {
    setRows(result);
    LoadUserData(result, true);
    HandleDisableParts(result.taskStatus);
    //set default values
    setSelectedPoolCode(result.poolId);
    setSelectedBreakdownReasonDetailCode(result.breakdownReasonDetailId);
    setSelectedBreakdownReasonGroupCode(result.breakdownReasonGroupId);
    setSelectedBreakdownEffectCode(result.breakdownEffectId);
    setSelectedBreakdownRootCauseCode(result.breakdownRootCauseId);
    setSelectedEquipment(result.equipmentId);
    setNotes(result.notes);
    setSparePart(result.freeTxt1);
    setSelectedBreakdownReasonPlaceName(result.breakdownTaskPlaceName);
    setSelectedBreakdownReasonDetailName(result.breakdownReasonDetailName);
    setSelectedBreakdownRootCauseName(result.breakdownRootCauseName);
    setStartDate(
      result.taskStatus !== 1 && result.taskStatus !== 2 ? result.startDate : moment().format("YYYY-MM-DDTHH:mm")
    );
    setEndDate(result.taskStatus === 5 ? result.completedDate : moment().format());
    if (result.notes) {
      setNoteErrorStatus(false);
      setNoteErrorText("");
    }
  };

  //load detail data for popup
  let [breakdownReasonGroupData, setBreakDownReasonGroupData] = useState([]);
  let [poolData, setPoolData] = useState([]);
  let [breakdownEffectData, setBreakdownEffectData] = useState([]);
  const [editRequestPopup, setEditRequestPopup] = useState(false);
  const LoadEditRequestData = () => {
    dispatch(getBreakdownPoolList({ editRequest: true }));
  };

  //load user data for popup
  const [assignPopup, setAssignPopup] = useState(false);
  let [userData, setUserData] = useState([]);
  const LoadUserData = (rows, openAssignPopup) => {
    let isArray = Array.isArray(rows);
    if (isArray) {
      dispatch(getTechnicianList({ rows: rows[0], poolId: rows[0].poolId }));
    } else {
      dispatch(getTechnicianList({ rows: rows, poolId: rows.poolId }));
    }
  };

  let [addFriendUserData, setAddFriendUserData] = useState(null);
  const LoadAddFriendUserData = (rows, userData, techList) => {
    let list = [];

    if (techList) {
      for (let i = 0; i < userData.length; i++) {
        let addUser = true;
        for (let j = 0; j < techList.length; j++) {
          if (techList[j].userCode.toLowerCase() == userData[i].userCode.toLowerCase()) {
            addUser = false;
          }
        }
        if (userData[i].userName == rows.assigneeName) {
          addUser = false;
        }
        if (addUser) {
          list.push(userData[i]);
        }
      }
    }

    setAddFriendUserData(list);
  };

  //go breakdown detail page
  const BackToBreakdownListPage = () => {
    props.history.goBack();
  };

  //set breakdown root cause
  let [selectedBreakdownRootCauseCode, setSelectedBreakdownRootCauseCode] = useState(0);
  let [selectedBreakdownRootCauseName, setSelectedBreakdownRootCauseName] = useState("");

  useEffect(() => {
    const savedRootCauseName = sessionStorage.getItem("selectedBreakdownRootCauseName");
    if (savedRootCauseName && breakdownRootCause.length > 0) {
      setRootCauseErrorStatus(false);
      setRootCauseErrorText("");
      setSelectedBreakdownRootCauseName(savedRootCauseName);
      const filtered = breakdownRootCause.find(
        (item) => item.name === savedRootCauseName || item.breakdownRootCauseLocalizationName === savedRootCauseName
      );
      if (filtered) {
        setSelectedBreakdownRootCauseCode(filtered.id);
      }
    }
  }, [breakdownRootCause, taskId]);

  const HandleBreakdownRootCause = (breakdownRootCauseName) => {
    setSelectedBreakdownRootCauseName(breakdownRootCauseName);
    if (breakdownRootCauseName != null) {
      sessionStorage.setItem("selectedBreakdownRootCauseName", breakdownRootCauseName);

      const filteredBreakdownRootCause = breakdownRootCause.filter(
        (item) =>
          item.name?.includes(breakdownRootCauseName) ||
          item.breakdownRootCauseLocalizationName?.includes(breakdownRootCauseName)
      );

      if (filteredBreakdownRootCause.length > 0) {
        setSelectedBreakdownRootCauseCode(filteredBreakdownRootCause[0].id);
        setRootCauseErrorStatus(false);
        setRootCauseErrorText("");
        return filteredBreakdownRootCause[0].id;
      }
    }
    setRootCauseErrorStatus(true);
    setRootCauseErrorText(t("EmptyCheck"));
    setSelectedBreakdownRootCauseCode(0);
  };

  //speed dial
  const [openSpeedDial, setOpenSpeedDial] = useState(false);
  const HandleOpenSpeedDial = (data) => {
    //for completed, closed, canceled status, it should be disabled
    if (data.taskStatus !== 6 && data.taskStatus !== 7) {
      setOpenSpeedDial(true);
    }
  };

  const HandleCloseSpeedDial = () => {
    setOpenSpeedDial(false);
  };

  //edit request details
  //set breakdownReasonGroupCode
  let [selectedBreakdownReasonGroupCode, setSelectedBreakdownReasonGroupCode] = useState();
  const HandleBreakdownReasonGroupChange = (breakdownReasonGroup) => {
    if (breakdownReasonGroup != null) {
      const filteredBreakdownReasonGroupChange = breakdownReasonGroupData.filter(
        (item) =>
          item.name?.includes(breakdownReasonGroup) ||
          item.breakdownReasonGroupLocalizationName?.includes(breakdownReasonGroup)
      );
      if (filteredBreakdownReasonGroupChange) {
        setSelectedBreakdownReasonGroupCode(filteredBreakdownReasonGroupChange[0].id);
      }

      return filteredBreakdownReasonGroupChange[0].id;
    }
    setSelectedBreakdownReasonGroupCode(0);
  };

  //set poolCode
  let [selectedPoolCode, setSelectedPoolCode] = useState();
  const HandlePoolChange = (poolId) => {
    if (poolId != null) {
      const filteredPool = poolData.filter((item) => item.name.includes(poolId));
      setSelectedPoolCode(filteredPool[0].id);
      return filteredPool[0].id;
    }
    setSelectedPoolCode(0);
  };

  //set breakdownEffectCode
  let [selectedBreakdownEffectCode, setSelectedBreakdownEffectCode] = useState();
  const HandleBreakdownEffectChange = (effectId) => {
    if (effectId != null) {
      const filteredEffect = breakdownEffectData.filter(
        (item) => item.name?.includes(effectId) || item.breakdownEffectLocalizationName?.includes(effectId)
      );
      setSelectedBreakdownEffectCode(filteredEffect[0].id);
      return filteredEffect[0].id;
    }
    setSelectedBreakdownEffectCode(0);
  };

  const HandleEkedEquipment = (equipments) => {
    let ids = [];
    let names = [];
    equipments.map((item) => ids.push(item.id));
    equipments.map((item) => names.push(item.name));
    if (equipments == null) {
      setTempEkedEquipmentIds([]);
      setTempEkedEquipmentNames([]);
    } else {
      setTempEkedEquipmentIds(ids);
      setTempEkedEquipmentNames(names);
    }
  };

  const OpenEditRequest = () => {
    setOpenSpeedDial(false);
    LoadEditRequestData();
  };

  const [openAddFriendPopup, setOpenAddFriendPopup] = useState(false);
  const OpenAddFriend = () => {
    setOpenAddFriendPopup(true);
  };

  const CloseAddFriendPopup = () => {
    setOpenAddFriendPopup(false);
  };

  let [selectedFriend, setSelectedFriend] = useState();
  const HandleAddFriend = (userName) => {
    if (userName != null && addFriendUserData != null) {
      const filteredFriend = addFriendUserData.filter((item) => item.userName.includes(userName));
      setSelectedFriend(filteredFriend[0].userCode);
      return filteredFriend[0].id;
    }
  };

  const AddFriend = (rowData) => {
    dispatch(addTechnician({ taskId: rowData.id, userCode: selectedFriend }));
    setOpenAddFriendPopup(false);
  };

  const CancelEditRequest = () => {
    setSelectedPoolCode(rows.poolId);
    setSelectedBreakdownReasonGroupCode(rows.breakdownReasonGroupId);
    setSelectedBreakdownEffectCode(rows.breakdownEffectId);
    setEditRequestPopup(false);
  };

  //add friend popup
  //set userCode
  let [selectedUserCode, setSelectedUserCode] = useState();
  const HandleUserChange = (userName) => {
    if (userName != null) {
      const filteredUserName = userData.filter((item) => item.userName.includes(userName));
      setSelectedUserCode(filteredUserName[0].userCode);
      return filteredUserName[0].id;
    }
  };

  const OpenAssign = () => {
    setOpenSpeedDial(false);
    setAssignPopup(true);
  };

  const CancelAssign = () => {
    setSelectedUserCode();
    setAssignPopup(false);
  };

  const [openSubtaskPopup, setOpenSubtaskPopup] = useState(false);
  const [subTaskNote, setSubTaskNote] = useState("");
  const [subtaskPool, setSubtaskPool] = useState(null);

  const HandleSubTaskPool = (poolId) => {
    if (poolId != null) {
      const filteredSubTaskPool = poolData.filter((item) => item.name.includes(poolId));
      setSubtaskPool(filteredSubTaskPool[0].id);
      return filteredSubTaskPool[0].id;
    }
    setSubtaskPool(null);
  };

  const OpenCreateSubtask = () => {
    dispatch(getBreakdownPoolList({ createSubTask: true }));
  };

  const CancelCreateSubtask = () => {
    setOpenSubtaskPopup(false);
    setSubtaskPool(null);
    setSubTaskNote("");
  };

  const CreateSubtask = (rowData) => {
    setOpenSubtaskPopup(false);
    dispatch(
      createSubTask({
        id: rowData.id,
        poolId: subtaskPool,
        taskInitialNote: subTaskNote,
      })
    );
    setSubtaskPool(null);
    setSubTaskNote("");
  };

  //create subtask
  // const openCreateSubtask = () => {
  //     setOpenSpeedDial(false);
  //     props.history.push("reportbreakdown");
  // };

  //assign to me
  const AssignToMe = (rowData) => {
    dispatch(assignTask({ id: rowData.id, userCode: userID }));
  };

  //assign to someone
  const AssignToSomeone = (rowData) => {
    dispatch(assignTask({ id: rowData.id, userCode: selectedUserCode }));
    setAssignPopup(false);
  };

  const HasUserActiveTask = () => {
    // let payload = {
    //     id: 3,
    //     UserActiveTask: true,
    // };
    // dispatch(getListByStatusUnPlannedMaintenance(payload));
    dispatch(getCurrentUsersActiveTaskId());
  };

  const GoToStartedTask = () => {
    // let payload = {
    //     id: 3,
    //     goToStartedTask: true,
    // };
    // dispatch(getListByStatusUnPlannedMaintenance(payload));
    if (currentUsersActiveTaskId != null) {
      setActiveUsersTaskPopup(false);
      setCurrentUsersActiveTaskId(null);
      setIsUserAssignee(false);
      history.push("breakdowndetail?id=" + currentUsersActiveTaskId); //go to active task if user has.
      window.location.reload();
    }
  };

  const RemoveTechnician = () => {
    let data = {
      taskId: currentUsersActiveTaskId,
      userCode: userID,
    };
    dispatch(deleteTechnicianFromUnplanned(data));
    setActiveUsersTaskPopup(false);
    setCurrentUsersActiveTaskId(null);
    setIsUserAssignee(false);
  };
  const CloseActiveUsersTaskPopup = () => {
    setActiveUsersTaskPopup(false);
  };

  const EkedEquipmentPopupHandler = () => {
    setSecurityDialogOpen(true);
  };

  //start task
  const StartTask = (rowData) => {
    setSecurityDialogOpen(true);
    setDisabledEked(false);
    setStartPayload({
      id: 3,
      startTask: true,
      rowData: rowData,
    });
  };

  //complete task
  const CompleteTask = (rowData) => {
    const data = {
      id: rowData.id,
      maintenanceOrderId: rowData.maintenanceOrderId,
      equipmentId: selectedEquipment,
      notes: notes != null ? notes : sessionStorage.getItem("notes"),
      breakdownReasonDetailId:
        selectedBreakdownReasonDetailCode > 0
          ? selectedBreakdownReasonDetailCode
          : sessionStorage.getItem("breakdownReasonDetailId"),
      breakdownRootCauseId: selectedBreakdownRootCauseCode,
      breakdownEffectId: selectedBreakdownEffectCode,
      FreeTxt1: sparePart,
      poolId: selectedPoolCode,
      isEnvNotClean: isEnvNotClean,
    };
    if (rowData.taskStatus === 5) {
      if (rowData.creatorCode === PDM_USER_CODE) {
        // Pass p360Payload to saga — P360 will be called only after successful close
        const p360Payload = {
          mostWorkOrderId: String(rowData.id),
          isValidAlarm: true,
          summary: rowData.notes,
          comment: rowData.orderNote,
          level: rowData.priority,
          userName: rowData.assigneeName,
          closedDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
        };
        const plantId = rowData.plantId ?? Number(localStorage.getItem("plantId")) ?? null;
        console.log("PDM Close Payload:", { taskId: rowData.id, p360Payload, plantId });
        dispatch(closeUnPlannedMaintenance({ taskId: rowData.id, p360Payload, plantId }));
      } else {
        // Normal close flow for non-PDM users
        dispatch(closeUnPlannedMaintenance(rowData.id));
      }
    } else {
      dispatch(completeUnPlannedMaintenance(data));
    }
  };

  //pause task
  const PauseTask = (rowData) => {
    const { id } = rowData;
    const pauseReasonId = selectedMaintenancePauseReasonCode ? selectedMaintenancePauseReasonCode : 0;
    const pauseReasonNote = maintenancePauseNote;
    dispatch(pauseUnPlannedMaintenance({ taskId: id, pauseReasonId, pauseReasonNote }));
    setPausePopup(false);
    setMaintenancePauseNote("");
    setSelectedMaintenancePauseReasonCode();
    setSelectedBreakdownReasonPlaceName("");
    setSelectedBreakdownReasonDetailName("");
    setSelectedBreakdownRootCauseName("");

    setBreakdownDetailErrorStatus(false);
    setRootCauseErrorStatus(false);
    setNoteErrorStatus(false);
  };

  //update task
  const UpdateTask = (rowData) => {
    const data = {
      id: rowData.id,
      maintenanceOrderId: rowData.maintenanceOrderId,
      equipmentId: selectedEquipment,
      poolId: selectedPoolCode,
      breakdownReasonDetailId:
        selectedBreakdownReasonDetailCode > 0
          ? selectedBreakdownReasonDetailCode
          : sessionStorage.getItem("breakdownReasonDetailId") ?? 0,
      breakdownReasonGroupId: selectedBreakdownReasonGroupCode,
      breakdownRootCauseId: selectedBreakdownRootCauseCode,
      breakdownEffectId: selectedBreakdownEffectCode,
      notes: notes != null ? notes : sessionStorage.getItem("notes") ?? "",
      FreeTxt1: sparePart,
    };

    if (selectedEquipmentName) setEditedEquipment(selectedEquipmentName); //sets new equipment name when equipment name change on "Edit job order"

    dispatch(updateUnPlannedMaintenance(data));

    setEditRequestPopup(false);
  };

  const ReOpenTask = (value) => {
    setRootCauseErrorStatus(false);
    setRootCauseErrorText("");
    dispatch(reopenUnplannedMaintenance(value.id));
  };

  const AddMe = () => {
    if (assigneeID !== userID) {
      const taskId = new URLSearchParams(props.location.search).get("id");
      dispatch(addTechnician({ taskId, userCode: userID }));
    } else {
      renderToaster(enqueueSnackbar, handleBackendMessage(t("InvalidAction")), "error");
    }
    setOpenSpeedDial(false);
  };

  const OpenPlannedMaintenance = () => {
    props.history.push(
      "/create-planned-maintenance?from=breakdown&bdid=" +
        new URLSearchParams(props.location.search).get("id") +
        "&equipmentid=" +
        rows.equipmentId +
        "&poolid=" +
        rows.poolId +
        "&equipmentname=" +
        rows.equipmentName +
        "&poolname=" +
        rows.poolName
    );
  };

  const OpenToBePlanned = () => {
    const note = rows.orderNote === null ? "" : rows.orderNote;
    history.push(
      "/create-to-be-planned?from=breakdown&bdid=" +
        new URLSearchParams(props.location.search).get("id") +
        "&equipmentid=" +
        rows.equipmentId +
        "&poolid=" +
        rows.poolId +
        "&equipmentname=" +
        rows.equipmentName +
        "&poolname=" +
        rows.poolName +
        "&note=" +
        note
    );
  };

  const OpenEquipmentNotes = () => {
    history.push("equipment-notes?id=" + rows.equipmentId, {
      equipmentId: rows.equipmentId,
      equipmentName: rows.equipmentName,
    });
  };

  const [unplannedMaintenanceReportNote, setUnplannedMaintenanceReportNote] = useState("");
  const [unplannedMaintenanceReportPopup, setUnplannedMaintenanceReportPopup] = useState(false);
  const handleUnplannedMaintenanceReportPopupOpen = () => {
    setUnplannedMaintenanceReportPopup(true);
  };
  const handleunplannedMaintenanceReportPopupClose = () => {
    let payload = {
      taskId: rows.id,
      startDate: startDate,
      endDate: endDate,
      note: unplannedMaintenanceReportNote,
    };
    dispatch(addUnPlannedMaintenanceOfTheReport(payload));
    handleunplannedMaintenanceReportPopupCancel();
  };

  const deleteReportsButtonHandler = (row) => {
    dispatch(deleteUnPlannedMaintenanceOfTheReports(row.id));
  };

  const handleunplannedMaintenanceReportPopupCancel = () => {
    setUnplannedMaintenanceReportPopup(false);
    setStartDate(rows.taskStatus !== 1 && rows.taskStatus !== 2 ? rows.startDate : moment().format("YYYY-MM-DDTHH:mm"));
    setEndDate(rows.taskStatus === 5 ? rows.completedDate : moment().format("YYYY-MM-DDTHH:mm"));
    setUnplannedMaintenanceReportNote("");
  };

  const onStartDateChangeHandler = (date) => {
    setStartDate(moment(date).format());
  };

  const onEndDateChangeHandler = (date) => {
    setEndDate(moment(date).format());
  };

  const onNoteChangeHandler = (evt) => {
    setUnplannedMaintenanceReportNote(evt.target.value);
  };

  //set speed dial paramteters

  const actions = [
    { icon: <People />, name: t("EditJobOrder"), action: OpenEditRequest },
    {
      icon: <PersonAdd />,
      name: t("AssigntoAnotherPerson"),
      action: OpenAssign,
    },
    { icon: <PersonPinIcon />, name: t("AddMe"), action: AddMe },
    { icon: <RecordVoiceOver />, name: t("AddFriend"), action: OpenAddFriend },
    {
      icon: <TransferWithinAStationIcon />,
      name: t("CreateSubtask"),
      action: OpenCreateSubtask,
    },
    {
      icon: <Add />,
      name: t("OpenScheduledMaintenance"),
      action: OpenPlannedMaintenance,
    },
    {
      icon: <NoteAdd />,
      name: t("EquipmentNotes"),
      action: OpenEquipmentNotes,
    },
    { icon: <Add />, name: t("OpenToBePlanned"), action: OpenToBePlanned },
    // { icon: <Add />, name: 'Alt Çağrı Aç', action: openCreateSubtask },
  ];
  if (rows.taskStatus === 5 || rows.taskStatus === 3) {
    actions.push({
      icon: <AddAlarm />,
      name: t("NonReportTime"),
      action: handleUnplannedMaintenanceReportPopupOpen,
    });
  }

  useEffect(() => {
    const savedNotes = sessionStorage.getItem("notes");
    if (savedNotes) {
      setNotes(savedNotes);
      setNoteErrorStatus(false);
      setNoteErrorText("");
    } else {
      setNoteErrorStatus(true);
      setNoteErrorText(t("EmptyCheck"));
    }
  }, [taskId]);

  //notes
  const [notes, setNotes] = useState("");
  const HandleNotes = (event) => {
    setNotes(event.target.value);
    sessionStorage.setItem("notes", event.target.value);
    if (event.target.value.length === 0) {
      setNoteErrorStatus(true);
      setNoteErrorText(t("EmptyCheck"));
    } else if (event.target.value.length < 20) {
      setNoteErrorStatus(true);
      setNoteErrorText(t("MinCharacter20"));
    } else {
      setNoteErrorStatus(false);
      setNoteErrorText("");
    }
  };

  //spare part
  const [sparePart, setSparePart] = useState("");
  const HandleSparePart = (event) => {
    setSparePart(event.target.value);
  };

  //load breakdown reason group data for popup
  let [breakdownReasonGroupDataFilter, setBreakdownReasonGroupDataFilter] = useState([]);
  const LoadBreakdownReasonGroup = () => {
    if (rows.poolId != undefined || rows.poolId != null) dispatch(getBreakdownReasonListWithPoolRelations(rows.poolId));
  };

  let [selectedBreakdownReasonGroupFilter, setSelectedBreakdownReasonGroupFilter] = useState([]);

  const [breakdownReasonGroupName, setBreakdownReasonGroupName] = useState();

  useEffect(() => {
    const savedBreakdownReasonGroup = sessionStorage.getItem("selectedBreakdownReasonGroupFilter");

    if (savedBreakdownReasonGroup && breakdownReasonGroupDataFilter.length > 0) {
      setBreakdownReasonGroupName(savedBreakdownReasonGroup);
      const filtered = breakdownReasonGroupDataFilter.find(
        (item) =>
          item.name === savedBreakdownReasonGroup ||
          item.breakdownReasonGroupLocalizationName === savedBreakdownReasonGroup
      );
      if (filtered != null) {
        setSelectedBreakdownReasonGroupFilter(filtered.id);
        LoadBreakdownReasonPlace(filtered.id);
      }
    }
  }, [breakdownReasonGroupDataFilter, taskId]);

  const HandleBreakdownReasonGroupFilter = (breakdownReasonGroup) => {
    if (breakdownReasonGroup != null) {
      setBreakdownReasonGroupName(breakdownReasonGroup);
      sessionStorage.setItem("selectedBreakdownReasonGroupFilter", breakdownReasonGroup);
      const filteredBreakdownReasonGroup = breakdownReasonGroupDataFilter.filter(
        (item) =>
          item.name?.includes(breakdownReasonGroup) ||
          item.breakdownReasonGroupLocalizationName?.includes(breakdownReasonGroup)
      );
      if (filteredBreakdownReasonGroup) {
        setSelectedBreakdownReasonGroupFilter(filteredBreakdownReasonGroup[0].id);
        LoadBreakdownReasonPlace(filteredBreakdownReasonGroup[0].id);
      }
      return filteredBreakdownReasonGroup[0].id;
    }
  };

  //load breakdown place data filtered by breakdown reason group
  let [breakdownReasonPlace, setBreakdownReasonPlace] = useState([]);
  const LoadBreakdownReasonPlace = (data) => {
    if (data) {
      dispatch(
        getBreakdownReasonPlaceListByGroupIdAndPoolRelations({
          id: data,
          poolId: rows.poolId,
        })
      );
    }
  };

  let [selectedBreakdownReasonPlaceCode, setSelectedBreakdownReasonPlaceCode] = useState([]);
  const [selectedBreakdownReasonPlaceName, setSelectedBreakdownReasonPlaceName] = useState();

  useEffect(() => {
    const savedPlace = sessionStorage.getItem("selectedBreakdownReasonPlace");
    if (savedPlace && breakdownReasonPlace.length > 0) {
      setSelectedBreakdownReasonPlaceName(savedPlace);
      const filtered = breakdownReasonPlace.find(
        (item) => item.name === savedPlace || item.breakdownReasonGroupLocalizationName === savedPlace
      );
      if (filtered) {
        setSelectedBreakdownReasonPlaceCode(filtered.id);
        LoadBreakdownReasonDetail(filtered.id);
      }
    }
  }, [breakdownReasonPlace, taskId]);

  //breakdown Location
  const HandleBreakdownReasonPlace = (reasonPlace) => {
    if (reasonPlace != null) {
      const filtered = breakdownReasonPlace.find(
        (item) => item.name === reasonPlace || item.breakdownReasonPlaceLocalizationName === reasonPlace
      );

      if (filtered) {
        const { id, name } = filtered;

        setSelectedBreakdownReasonPlaceCode(id);
        setSelectedBreakdownReasonPlaceName(name);
        setBreakdownDetailErrorStatus(false);
        setBreakdownDetailErrorText("");
        LoadBreakdownReasonDetail(id);
        sessionStorage.setItem("selectedBreakdownReasonPlace", name);

        return id;
      }
    }
  };

  //load breakdown place data filtered by breakdown reason group
  let [breakdownReasonDetail, setBreakdownReasonDetail] = useState([]);
  const LoadBreakdownReasonDetail = (data) => {
    if (data) dispatch(getBreakdownReasonDetailListByPlaceId(data));
  };

  //set breakdown reason detail
  const [selectedBreakdownReasonDetailCode, setSelectedBreakdownReasonDetailCode] = useState(-1);
  const [selectedBreakdownReasonDetailName, setSelectedBreakdownReasonDetailName] = useState();

  useEffect(() => {
    const savedBreakdownDetailReason = sessionStorage.getItem("selectedBreakdownReasonDetailName");
    if (savedBreakdownDetailReason && breakdownReasonDetail.length > 0) {
      setSelectedBreakdownReasonDetailName(savedBreakdownDetailReason);
      const filtered = breakdownReasonDetail.find(
        (item) =>
          item.name === savedBreakdownDetailReason ||
          item.breakdownReasonDetailLocalizationName === savedBreakdownDetailReason
      );
      if (filtered) {
        setSelectedBreakdownReasonDetailCode(filtered.id);
        setBreakdownDetailErrorStatus(false);
        setBreakdownDetailErrorText("");
      }
    }
  }, [breakdownReasonDetail, taskId]);

  const HandleBreakdownReasonDetail = (breakdownDetail) => {
    if (breakdownDetail != null) {
      const filteredBreakdownDetailReason = breakdownReasonDetail.filter(
        (item) =>
          item.name?.includes(breakdownDetail) || item.breakdownReasonDetailLocalizationName?.includes(breakdownDetail)
      );
      if (filteredBreakdownDetailReason) {
        sessionStorage.setItem("selectedBreakdownReasonDetailName", filteredBreakdownDetailReason[0].name);
        setSelectedBreakdownReasonDetailName(filteredBreakdownDetailReason[0].name);

        setSelectedBreakdownReasonDetailCode(filteredBreakdownDetailReason[0].id);
        sessionStorage.setItem("breakdownReasonDetailId", filteredBreakdownDetailReason[0].id);
      }
      return filteredBreakdownDetailReason[0].id;
    }
  };

  //set root equipment
  let [selectedEquipment, setSelectedEquipment] = useState(0);
  let [selectedEquipmentName, setSelectedEquipmentName] = useState(0);
  const HandleEquipment = (equipmentName) => {
    if (equipmentName != null) {
      const filteredEquipment = equipmentInfo.filter((item) => item.name.includes(equipmentName));
      setSelectedEquipmentName(equipmentName);
      setSelectedEquipment(filteredEquipment[0].id);
      return filteredEquipment[0].id;
    }
    setSelectedEquipmentName(null);
    setSelectedEquipment(0);
  };

  //breakdown detail popup
  const [breakdownDetailPopup, setBreakdownDetailPopup] = useState(false);
  const HandleBreakdownDetailOpen = () => {
    LoadBreakdownReasonGroup();
  };
  const HandleBreakdownDetailClose = () => {
    setBreakdownDetailPopup(false);
  };

  //disable enable buttons
  const [disableBreakdownDetail, setDisableBreakdownDetail] = useState(false);
  const [disableBreakdownRootCause, setDisableBreakdownRootCause] = useState(false);
  const [disableNote, setDisableNote] = useState(false);
  const [disableEquipment, setDisableEquipment] = useState(false);
  const [disableSparePart, setDisableSparePart] = useState(false);
  const [disableDocumentButton, setDisableDocumentButton] = useState(false);
  const [disableAssignButton, setDisableAssignButton] = useState(false);
  const [disableStartButton, setDisableStartButton] = useState(false);
  const [disableFinishButton, setDisableFinishButton] = useState(false);
  const [disableFinishButtonValidation, setDisableFinishButtonValidation] = useState(false);
  const [disablePauseButton, setDisablePauseButton] = useState(false);
  const [disableEnvCheckbox, setDisableEnvCheckbox] = useState(false);

  const Disable = (list) => {
    setDisableBreakdownDetail(list[0]);
    setDisableBreakdownRootCause(list[1]);
    setDisableNote(list[2]);
    setDisableEquipment(list[3]);
    setDisableSparePart(list[4]);
    setDisableDocumentButton(list[5]);
    setDisableAssignButton(list[6]);
    setDisableStartButton(list[7]);
    setDisableFinishButton(list[8]);
    setDisablePauseButton(list[9]);
    setDisabledEked(list[10]);
    setDisableEnvCheckbox(list[11]);
  };

  // Handle Visibilities
  const [visibleBreakdownDetail, setVisibleBreakdownDetail] = useState(false);
  const [visibleBreakdownRootCause, setVisibleBreakdownRootCause] = useState(false);
  const [visibleNote, setVisibleNote] = useState(false);
  const [visibleEnvCheckbox, setVisibleEnvCheckbox] = useState(false);

  const Visible = (list) => {
    setVisibleBreakdownDetail(list[0]);
    setVisibleBreakdownRootCause(list[1]);
    setVisibleNote(list[2]);
    setVisibleEnvCheckbox(list[3]);
  };

  //enable disable for status
  const HandleDisableParts = (status) => {
    //Atama Bekliyor
    if (status === 1) {
      Disable([true, true, true, true, true, true, false, true, true, true, true, true]);
      Visible([false, false, false, false]);
    }

    //Atandı
    else if (status === 2) {
      Disable([true, true, true, true, true, true, false, false, true, true, true, true]);
      Visible([false, false, false, false]);
      setIsDisableAddEwoButton(false);
    }

    //Başlandı
    else if (status === 3) {
      Disable([false, false, false, false, false, false, true, true, false, false, false, false]);
      Visible([true, true, true, true]);
      setIsDisableAddEwoButton(false);
    }

    //Durduruldu
    else if (status === 4) {
      Disable([true, true, true, true, true, true, false, false, true, true, true, false, true]);
      Visible([false, false, false, false]);
      setIsDisableAddEwoButton(false);
    }

    //Tamamlandı
    else if (status === 5) {
      Disable([false, false, false, false, false, false, true, false, false, false, false, true]);
      Visible([true, true, true, true]);
      setIsDisableAddEwoButton(false);
    }

    //Kapandı
    else if (status === 6) {
      Disable([true, true, true, true, true, true, true, true, true, true, true, true]);
      Visible([true, true, true, true]);
      setIsDisableAddEwoButton(false);
    }

    //İptal Edildi
    else if (status === 7) {
      Disable([true, true, true, true, true, true, true, true, true, true, true, true]);
      Visible([true, true, true, true]);
    }
  };

  // File Management
  const [documentPopup, setDocumentPopup] = useState(false);
  let [documentList, setDocumentList] = useState([]);
  const [equipmentFiles, setEquipmentFiles] = useState([]);

  const HandleDocumentOpen = () => {
    dispatch(getUnplannedFiles(rows.maintenanceOrderId));
    dispatch(getEquipmentFiles(rows.equipmentId));
  };

  const CloseDocumentPopup = () => {
    setDocumentPopup(false);
  };

  const DeleteFile = (selectedFiles) => {
    const selectedFileNames = getSelectedFileNames(selectedFiles);
    const payload = {
      unplannedId: rows.maintenanceOrderId,
      fileNames: selectedFileNames,
    };
    dispatch(deleteUnplannedFiles(payload));
    setDocumentPopup(false);
  };

  const DeleteEquipmentFile = (selectedFiles) => {
    const selectedFileNames = getSelectedFileNames(selectedFiles);
    const payload = {
      equipmentId: rows.equipmentId,
      fileNames: selectedFileNames,
    };
    dispatch(deleteEquipmentFiles(payload));
    setDocumentPopup(false);
  };

  const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
  const UploadFiles = (files) => {
    const formData = getFormDataFromFiles(files);
    const payload = {
      unplannedId: rows.maintenanceOrderId,
      data: formData,
    };
    dispatch(addUnplannedFiles(payload));
    setIsFileUploaderPopupOpen(false);
  };

  //timeline popup
  const [timelinePopup, setTimelinePopup] = useState(false);
  const CloseTimelinePopup = () => {
    setTimelinePopup(false);
  };

  const [timelineArray, setTimelineArray] = useState([]);
  const HandleTimelineOpen = () => {
    setTimelinePopup(true);
    dispatch(getTaskHistoryByIdUnPlannedMaintenance(rows.id));
  };

  const HandleOrderFormOpen = () => {
    let createDate = moment(rows.createdDate).format("DD.MM.YYYY");
    let data = {
      maintenanceOrderId: rows.maintenanceOrderId,
      equipmentName: rows.equipmentName,
      createdDate: createDate,
      notes: rows.notes,
      breakdownDetail: true,
      assigneeName: rows.assigneeName,
      areaGroupName: rows.areaName,
      breakdownGroupName: rows.breakdownReasonGroupName,
      costCenterCode: rows.costCenterCode,
    };
    props.history.push("/order-form?id=" + rows.id, data);
  };

  //pause popup
  const [pausePopup, setPausePopup] = useState(false);
  const [maintenancePauseReasonData, setMaintenancePauseReasonData] = useState([]);
  const OpenPausePopup = () => {
    dispatch(getMaintenancePauseReasonList());
  };

  const ClosePausePopup = () => {
    setPausePopup(false);
  };

  //set breakdown pause detail
  let [selectedMaintenancePauseReasonCode, setSelectedMaintenancePauseReasonCode] = useState();
  const HandleMaintenancePauseReason = (pauseName) => {
    if (pauseName != null) {
      const filteredPauseReason = maintenancePauseReasonData.filter((item) => item.name.includes(pauseName));
      setSelectedMaintenancePauseReasonCode(filteredPauseReason[0].id);
      return filteredPauseReason[0].id;
    } else {
      setSelectedMaintenancePauseReasonCode();
    }
  };

  const [maintenancePauseNote, setMaintenancePauseNote] = useState("");
  const HandleMaintenancePauseNote = (event) => {
    setMaintenancePauseNote(event.target.value);
  };

  const HandleSecurityDialogClose = () => {
    setIsChecked(ekedUsed);
    setTempEkedEquipmentIds(selectedEkedEquipmentIds);
    setTempEkedEquipmentNames(selectedEkedEquipmentNames);
    setSecurityDialogOpen(false);
    if (startPayload) {
      dispatch(getListByStatusUnPlannedMaintenance(startPayload));
      dispatch(getCurrentUsersActiveTaskId());
      setStartPayload(null);
    }
  };

  const HandleSecurityDialogConfirm = () => {
    setEkedUsed(isChecked);
    setSelectedEkedEquipmentIds(tempEkedEquipmentIds);
    setSelectedEkedEquipmentNames(tempEkedEquipmentNames);
    const id = queryString.parse(window.location.search).id;
    let data = {
      taskId: id,
      ekedUsed: isChecked,
      payload: tempEkedEquipmentIds,
    };
    dispatch(updateEkedEquipmentList(data));
    setSecurityDialogOpen(false);
    if (startPayload) {
      dispatch(getListByStatusUnPlannedMaintenance(startPayload));
      dispatch(getCurrentUsersActiveTaskId());
      setStartPayload(null);
    }
  };

  // Validation (Edit Request Popup)
  const [error, setError] = useState({
    breakdownEffectText: t("SelectABreakdownEffect"),
    breakdownReasonGroupText: t("SelectABreakdownReasonGroup"),
    equipmentText: t("SelectAnEquipment"),
  });
  const [isEditRequestButtonDisable, setIsEditRequestButtonDisable] = useState(true);

  useEffect(() => {
    const newBreakdownEffectText = selectedBreakdownEffectCode ? "" : t("SelectABreakdownEffect");
    const newBreakdownReasonGroupText = selectedBreakdownReasonGroupCode ? "" : t("SelectABreakdownReasonGroup");
    const newEquipmentText = selectedEquipment ? "" : t("SelectAnEquipment");

    setError({
      breakdownEffectText: newBreakdownEffectText,
      breakdownReasonGroupText: newBreakdownReasonGroupText,
      equipmentText: newEquipmentText,
    });
  }, [selectedBreakdownEffectCode, selectedBreakdownReasonGroupCode, selectedEquipment, editRequestPopup]);

  useEffect(() => {
    if (error.breakdownEffectText === "" && error.breakdownReasonGroupText === "" && error.equipmentText === "") {
      setIsEditRequestButtonDisable(false);
    } else {
      setIsEditRequestButtonDisable(true);
    }
  }, [error]);

  // Validation (Create Sub Task Popup)
  const [errorSubTaskPoolText, setErrorSubTaskPoolText] = useState("");
  const [isCreateSubTaskButtonDisable, setIsCreateSubTaskButtonDisable] = useState(true);

  useEffect(() => {
    const subTaskPoolText = subtaskPool ? "" : t("SelectAPool");
    setErrorSubTaskPoolText(subTaskPoolText);
  }, [subtaskPool, openSubtaskPopup]);

  useEffect(() => {
    if (errorSubTaskPoolText === "") {
      setIsCreateSubTaskButtonDisable(false);
    } else {
      setIsCreateSubTaskButtonDisable(true);
    }
  }, [errorSubTaskPoolText]);

  // Validation (Reports Popup)
  const [errorReports, setErrorReports] = useState({
    dateSelectedText: t("SelectADate"),
    startDateMinText: t("DateErrorStart"),
    endDateMaxText: t("DateErrorEnd"),
    dateMinText: t("DateError"),
    dateMaxText: t("DateErrorMax"),
    noteText: t("EnterANote"),
  });
  const [isReportsButtonDisable, setIsReportsButtonDisable] = useState(true);

  useEffect(() => {
    if (rows.createdDate && rows.completedDate) {
      const newDateSelectedText = startDate && endDate ? "" : t("SelectADate");
      const newDateMinText =
        new Date(endDate).toLocaleString() > new Date(startDate).toLocaleString() ? (
          ""
        ) : rows.taskStatus === 5 ? (
          <React.Fragment>
            {" "}
            {t("DateError") +
              " " +
              t("Task") +
              " " +
              t("StartDate") +
              " " +
              moment(rows.startDate).format("DD.MM.YYYY HH:mm")}{" "}
            <br /> {t("Task") + " " + t("EndDate") + " " + moment(rows.completedDate).format("DD.MM.YYYY HH:mm")}
          </React.Fragment>
        ) : (
          (console.log("startDate", new Date(startDate).toLocaleString()),
          console.log("endDate", new Date(endDate).toLocaleString()),
          t("DateError"))
        ); // "Bitiş tarihi başlangıç tarihinden küçük olamaz.",
      const newStartDateMinText =
        new Date(startDate).toLocaleString() >= new Date(rows.startDate).toLocaleString() ? (
          ""
        ) : (
          <React.Fragment>
            {" "}
            {t("DateErrorStart") + " " + t("StartDate") + " " + moment(rows.startDate).format("DD.MM.YYYY HH:mm")}
          </React.Fragment>
        ); // "Seçilen başlangıç tarihi task başlangıç tarihinden küçük olamaz.",
      const newEndDateMaxText =
        rows.taskStatus === 5 ? (
          new Date(endDate).toLocaleString() <= new Date(rows.completedDate).toLocaleString() ? (
            ""
          ) : (
            <React.Fragment>
              {" "}
              {t("DateErrorEnd")} <br /> {t("EndDate") + " " + moment(rows.completedDate).format("DD.MM.YYYY HH:mm")}
            </React.Fragment>
          )
        ) : (
          ""
        ); // "Bitiş tarihi, görevin tamamlandığı tarihten büyük olamaz.",
      const newDateMaxText =
        rows.taskStatus === 3 ? (
          new Date(endDate).toLocaleString() <= new Date().toLocaleString() &&
          new Date(startDate).toLocaleString() <= new Date().toLocaleString() ? (
            ""
          ) : (
            <React.Fragment>
              {" "}
              {t("DateErrorMax") + " " + t("StartDate") + " " + moment(rows.startDate).format("DD.MM.YYYY HH:mm")}{" "}
              <br /> {t("EndDate") + " " + moment(rows.endDate).format("DD.MM.YYYY HH:mm")}
            </React.Fragment>
          )
        ) : (
          ""
        ); // "Seçilen tarih ileri bir tarih olamaz.",
      const newNoteText = unplannedMaintenanceReportNote ? "" : t("EnterANote");

      setErrorReports({
        dateSelectedText: newDateSelectedText,
        startDateMinText: newStartDateMinText,
        endDateMaxText: newEndDateMaxText,
        dateMinText: newDateMinText,
        dateMaxText: newDateMaxText,
        noteText: newNoteText,
      });
    }
  }, [unplannedMaintenanceReportNote, startDate, endDate, editRequestPopup]);

  useEffect(() => {
    if (
      errorReports.dateSelectedText === "" &&
      errorReports.dateMinText === "" &&
      errorReports.dateMaxText === "" &&
      errorReports.noteText === "" &&
      errorReports.startDateMinText === "" &&
      errorReports.endDateMaxText === ""
    ) {
      setIsReportsButtonDisable(false);
    } else {
      setIsReportsButtonDisable(true);
    }
  }, [errorReports]);

  const HandleSparePartOpen = () => {
    props.history.push("/add-spare-part?id=" + rows.id, {
      taskId: rows.id,
      type: "breakdown",
    });
  };

  const EditEwoForm = () => {
    history.push("create-ewo-form?from=detail&id=" + rows.id, {
      data: rows,
      isEdit: true,
      ewoId: ewoForm?.ewoFormOperatorFields?.resultObject?.id,
    });
  };

  const CreateEwoForm = () => {
    history.push("create-ewo-form?from=detail&id=" + rows.id, { data: rows });
  };

  const ShowEwoForms = () => {
    history.push("ewoforms?from=breakdownDetail", { data: rows });
  };

  const isEwoPlants = (rows) => {
    const validCodes = ["Lipetsk IHPA WM", "MBI", "Lipetsk IHPA REF"];
    const validIds = [1078, 1079, 1080, 1081, 1082, 1083,46,47,48,49,50,51];

    return validCodes.includes(rows.plantCode) || validIds.includes(rows.plantId);
  };

  return (
    <div>
      {pageLoaded === true ? (
        <Container id="bd_container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
          <Grid id="bd_grid" container alignItems="center">
            <Grid id="bd_grid_1" item xs={1}>
              <IconButton id="bd_iconBtn" onClick={BackToBreakdownListPage} size="large">
                <ArrowBackIos id="bd_arrowBack" fontSize="inherit" align="end" />
              </IconButton>
            </Grid>
            <Grid id="bd_grid_2" item xs={11}>
              <Typography id="bd_typ" variant="h6" gutterBottom style={{ fontSize: 15 }}>
                {rows.equipmentDetailedCode}
              </Typography>
            </Grid>
          </Grid>

          <RequestCard
            id="bd_requestCard"
            rows={[rows]}
            detail={true}
            page="breakdownDetail"
            callName="Call"
            taskName="Task"
          />

          <Box id="bd_box" pt={1} pb={1} style={{ marginTop: 10 }} border={1} borderRadius="10px">
            <Grid id="bd_grid_3" container>
              {isEwoPlants(rows) ? (
                <Grid container>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{
                          width: "90%",
                          margin: "0 auto",
                          justifyContent: "flex-start",
                        }}
                      >
                        {/* ADD EWO FORM */}
                        <Tooltip
                          title={
                            completedEwoForm
                              ? t("ThisTaskHasEwoFormWhichIs", { code: ewoCode })
                              : emptyEwoForm
                              ? t("NoEwoForm")
                              : ""
                          }
                        >
                          <span>
                            <Button
                              id="btn_add_ewo"
                              size="small"
                              disabled={completedEwoForm || emptyEwoForm || isDisableAddEwoButton}
                              onClick={CreateEwoForm}
                              variant="contained"
                              color="primary"
                              sx={{
                                minWidth: 100,
                                minHeight: 28,
                                padding: "3px 8px",
                              }}
                            >
                              <Typography variant="body2" sx={{ fontSize: 10 }}>
                                {t("AddEwoForm")}
                              </Typography>
                            </Button>
                          </span>
                        </Tooltip>

                        {/* EDIT EWO FORM */}
                        <Button
                          id="btn_edit_ewo"
                          size="small"
                          disabled={emptyEwoForm || !completedEwoForm}
                          onClick={EditEwoForm}
                          variant="contained"
                          color="secondary"
                          sx={{
                            minWidth: 100,
                            minHeight: 28,
                            padding: "3px 8px",
                          }}
                        >
                          <Typography variant="body2" sx={{ fontSize: 10 }}>
                            {t("EditEwoFrom")}
                          </Typography>
                        </Button>

                        {/* SHOW EWO FORMS */}
                        <Button
                          id="btn_show_ewo"
                          size="small"
                          onClick={ShowEwoForms}
                          variant="contained"
                          color="info"
                          sx={{
                            minWidth: 100,
                            minHeight: 28,
                            padding: "3px 8px",
                          }}
                        >
                          <Typography variant="body2" sx={{ fontSize: 10 }}>
                            {t("EwoFormsEquipment")}
                          </Typography>
                        </Button>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}
              <Grid id="bd_grid_4" item xs={12}>
                {visibleBreakdownDetail ? (
                  <FormControl id="bd_fromControl" variant="outlined" style={{ width: "90%", marginTop: 15 }}>
                    <TextField
                      id="bd_textField"
                      label={t("BreakdownDetail")}
                      variant="outlined"
                      value={
                        selectedBreakdownReasonDetailName && selectedBreakdownReasonPlaceName
                          ? selectedBreakdownReasonPlaceName + " - " + selectedBreakdownReasonDetailName
                          : breakdownDetailName
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={breakdownDetailErrorStatus}
                      helperText={breakdownDetailErrorText}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <IconButton
                            id="bd_iconBtn_1"
                            onClick={() => {
                              HandleBreakdownDetailOpen();
                              setBreakdownDetailPopup(true);
                            }}
                            disabled={disableBreakdownDetail}
                            size="large"
                          >
                            <AddBox id="bd_addBox" color="primary" />
                          </IconButton>
                        ),
                      }}
                      disabled={disableBreakdownDetail}
                    />
                  </FormControl>
                ) : null}
                {visibleBreakdownRootCause ? (
                  <FormControl id="bd_fromControl_1" variant="outlined" style={{ width: "90%", marginTop: 15 }}>
                    <Autocomplete
                      id="bd_autocomplete"
                      defaultValue={rows != null ? rows.breakdownRootCauseName : ""}
                      value={selectedBreakdownRootCauseName != null ? selectedBreakdownRootCauseName : ""}
                      style={{ marginTop: -15 }}
                      onChange={(event, newValue) => {
                        HandleBreakdownRootCause(newValue);
                      }}
                      options={breakdownRootCause.map(
                        (option) => option.breakdownRootCauseLocalizationName ?? option.name
                      )}
                      renderInput={(params) => (
                        <TextField
                          id="bd_textFiled_1"
                          {...params}
                          margin="normal"
                          error={rootCauseErrorStatus}
                          helperText={rootCauseErrorText}
                          label={t("BreakdownRootCause")}
                          variant="outlined"
                        />
                      )}
                      disabled={disableBreakdownRootCause}
                    />
                  </FormControl>
                ) : null}
                {visibleNote ? (
                  <TextField
                    id="bd_textFiled_2"
                    style={{ width: "90%", marginTop: 15 }}
                    label={t("Note")}
                    multiline
                    variant="outlined"
                    defaultValue={rows.notes != null ? rows.notes : sessionStorage.getItem("notes")}
                    value={notes}
                    onChange={HandleNotes}
                    disabled={disableNote}
                    error={noteErrorStatus}
                    helperText={noteErrorText}
                  />
                ) : null}
              </Grid>
              <Grid id="bd_grid_5" item xs={12} align="center">
                <Accordion id="bd_accordion" style={{ width: "90%", marginTop: 15 }}>
                  <AccordionSummary
                    id="bd_accordionSum"
                    expandIcon={<ExpandMore id="bd_expandMore" />}
                    aria-controls="panel1c-content"
                  >
                    <Typography id="bd_typ_1" variant="body1" align="left">
                      {t("More")}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails id="bd_accordionDet">
                    <Grid id="bd_grid_6" container>
                      <Grid id="bd_grid_7" item xs={12} align="left">
                        <FormControl
                          id="bd_fromControl_2"
                          variant="outlined"
                          style={{ width: "100%" }}
                          disabled={disableEquipment}
                        >
                          {rows.taskStatus != 6 ? (
                            <Autocomplete
                              id="bd_autocomplete_1"
                              defaultValue={rows != null ? rows.equipmentName : ""}
                              value={editedEquipment != null ? editedEquipment : rows.equipmentName}
                              style={{ marginTop: -15 }}
                              onChange={(event, newValue) => {
                                HandleEquipment(newValue);
                              }}
                              disabled={disableEquipment}
                              options={rows.taskStatus !== 6 ? equipmentInfo.map((option) => option.name) : []}
                              renderInput={(params) => (
                                <TextField
                                  id="bd_textFiled_3"
                                  {...params}
                                  margin="normal"
                                  label={t("Equipment")}
                                  variant="outlined"
                                />
                              )}
                            />
                          ) : (
                            <TextField
                              id="bd_textFiled_20"
                              margin="normal"
                              label={t("Equipment")}
                              variant="outlined"
                              value={rows.equipmentName}
                              disabled={true}
                            />
                          )}
                        </FormControl>
                      </Grid>
                      {userIList.includes("VIEWER") ? null : (
                        <Grid container id="bd_grid_8" item xs={12}>
                          {hasSparePart ? (
                            <Grid item id="bd_spare_part_grd" xs={12}>
                              <Button
                                id="bd_sparePart_btn"
                                variant="contained"
                                color={"primary"}
                                style={{ width: "100%" }}
                                onClick={HandleSparePartOpen}
                              >
                                {t("AddSparePart")}
                              </Button>
                            </Grid>
                          ) : (
                            <Grid item id="bd_spare_part_text" xs={12}>
                              <TextField
                                id="bd_textFiled_4"
                                style={{ width: "100%", marginTop: 15 }}
                                align="left"
                                label={t("SparePart")}
                                multiline
                                variant="outlined"
                                defaultValue={rows.freeTxt1}
                                onChange={HandleSparePart}
                                disabled={disableSparePart}
                              />
                            </Grid>
                          )}
                        </Grid>
                      )}

                      <Grid id="bd_grid_9" item xs={3}>
                        <IconButton id="bd_iconBtn_2" onClick={HandleOrderFormOpen} size="large">
                          <Assignment id="bd_orderForm" className={classes.orderFormButtonStyle} />
                        </IconButton>
                      </Grid>

                      <Grid id="bd_grid_10" item xs={3}>
                        <IconButton id="bd_iconBtn_3" onClick={HandleTimelineOpen} size="large">
                          <Timelapse id="bd_timeLapse" className={classes.timeLapseButtonStyle} />
                        </IconButton>
                      </Grid>
                      <Grid id="bd_grid_11" item xs={3}>
                        <Tooltip title={t("ShowFiles")}>
                          <IconButton id="bd_iconBtn_4" onClick={HandleDocumentOpen} size="large">
                            <CloudDownload id="bd_downlaoad" className={classes.downloadDocButtonStyle} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                      <Grid id="bd_grid_12" item xs={3}>
                        <Tooltip title={t("UploadFile")}>
                          <IconButton
                            id="bd_iconBtn_5"
                            component="label"
                            disabled={disableDocumentButton}
                            onClick={() => setIsFileUploaderPopupOpen(true)}
                            size="large"
                          >
                            <CloudUpload id="bd_createNf" className={classes.uploadDocButtonStyle} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              {visibleEnvCheckbox ? (
                <Grid id="bd_grid_13" item xs={12} align="center" style={{ marginTop: 15 }}>
                  <FormControlLabel
                    id="bd_formControlLabel"
                    disabled={disableEnvCheckbox}
                    control={
                      <Checkbox
                        id="bd_isEnvNotCleanCheckbox"
                        color="success"
                        checked={isEnvNotClean}
                        onChange={(event) => setIsEnvNotClean(event.target.checked)}
                      />
                    }
                    label={
                      <Typography id="bd_typ_2" fontSize={13}>
                        {t("EnvironmentallyUnsuitable")}
                      </Typography>
                    }
                  />
                </Grid>
              ) : null}
              {userIList.includes("VIEWER") ? null : (
                <Grid id="bd_grid_20" item xs={12} align="center" style={{ marginTop: 15 }}>
                  <Button
                    variant="contained"
                    color={ekedUsed ? "primary" : "error"}
                    style={{ width: "90%" }}
                    onClick={EkedEquipmentPopupHandler}
                  >
                    {ekedUsed ? t("EkedIsUsing") : t("EkedIsNotUsing")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
          {securityDialogOpen === true ? (
            <SecurityPopup
              disabledEked={disabledEked}
              securityDialogOpen={securityDialogOpen}
              HandleSecurityDialogClose={HandleSecurityDialogClose}
              HandleSecurityDialogConfirm={HandleSecurityDialogConfirm}
              HandleEkedEquipment={HandleEkedEquipment}
              selectedEkedEquipmentIds={selectedEkedEquipmentIds}
              setSelectedEkedEquipmentNames={setSelectedEkedEquipmentNames}
              setTempEkedEquipmentIds={setTempEkedEquipmentIds}
              tempEkedEquipmentIds={tempEkedEquipmentIds}
              tempEkedEquipmentNames={tempEkedEquipmentNames}
              setTempEkedEquipmentNames={setTempEkedEquipmentNames}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          ) : null}
          {userIList.includes("VIEWER") ? null : (
            <Box id="bd_box_1">
              <Grid
                id="bd_grid_13"
                style={{
                  display: "grid",
                  gridTemplateColumns: rows.taskStatus === 5 ? "repeat(5, 1fr)" : "repeat(4,1fr)",
                }}
              >
                <Grid id="bd_grid_14">
                  <IconButton
                    id="bd_iconBtn_6"
                    onClick={() => AssignToMe(rows)}
                    disabled={disableAssignButton}
                    className={classes.iconButtonLabel}
                    size="large"
                  >
                    <AccountCircle id="bd_accCircle" sx={iconButtonStyle} style={{ fill: "#536dfe" }} />
                    <Typography id="bd_typ_2" variant="subtitle2">
                      {t("AssignToMe")}
                    </Typography>
                  </IconButton>
                </Grid>
                {rows.taskStatus == 1 || rows.taskStatus == 2 || rows.taskStatus == 4 ? (
                  <Grid id="bd_grid_15">
                    <IconButton
                      id="bd_iconBtn_7"
                      onClick={() => StartTask(rows)}
                      disabled={disableStartButton}
                      className={classes.iconButtonLabel}
                      size="large"
                    >
                      <PlayCircleFilledWhite id="bd_playCircle" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                      <Typography id="bd_typ_3" variant="subtitle2">
                        {t("Start")}
                      </Typography>
                    </IconButton>
                  </Grid>
                ) : rows.taskStatus == 3 ? (
                  <Grid id="bd_grid_16">
                    <IconButton
                      id="bd_iconBtn_8"
                      onClick={OpenPausePopup}
                      disabled={disablePauseButton}
                      className={classes.iconButtonLabel}
                      size="large"
                    >
                      <PauseCircleFilled id="bd_pauseCircle" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                      <Typography id="bd_typ_4" variant="subtitle2">
                        {t("Pause")}
                      </Typography>
                    </IconButton>
                  </Grid>
                ) : (
                  <Grid id="bd_grid_17">
                    <IconButton
                      id="bd_iconBtn_9"
                      onClick={() => UpdateTask(rows)}
                      disabled={disableStartButton}
                      className={classes.iconButtonLabel}
                      size="large"
                    >
                      <Save id="bd_save" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                      <Typography id="bd_typ_5" variant="subtitle2">
                        {t("Save")}
                      </Typography>
                    </IconButton>
                  </Grid>
                )}
                {rows.taskStatus === 5 && (
                  <Grid id="bd_grid_20">
                    <IconButton
                      id="bd_iconBtn_11"
                      onClick={() => ReOpenTask(rows)}
                      disabled={disableFinishButton}
                      className={classes.iconButtonLabel}
                      size="large"
                    >
                      <RepeatOutlined id="bd_reOpen" sx={iconButtonStyle} style={{ fill: "#e352b0" }} />
                      <Typography id="bd_typ_7" variant="subtitle2">
                        {t("Reopen")}
                      </Typography>
                    </IconButton>
                  </Grid>
                )}
                {rows.taskStatus != 5 && rows.taskStatus != 6 ? (
                  <Grid id="bd_grid_18">
                    <IconButton
                      id="bd_iconBtn_10"
                      onClick={() => CompleteTask(rows)}
                      disabled={disableFinishButton || disableFinishButtonValidation}
                      className={classes.iconButtonLabel}
                      size="large"
                    >
                      <CheckCircle id="bd_checkCircle" sx={iconButtonStyle} style={{ fill: "#4caf50" }} />
                      <Typography id="bd_typ_6" variant="subtitle2">
                        {t("Complete")}
                      </Typography>
                    </IconButton>
                  </Grid>
                ) : (
                  <Grid id="bd_grid_19">
                    <IconButton
                      id="bd_iconBtn_12"
                      onClick={() => CompleteTask(rows)}
                      disabled={disableFinishButton}
                      className={classes.iconButtonLabel}
                      size="large"
                    >
                      <OfflinePin id="bd_offlinePin" sx={iconButtonStyle} style={{ fill: "#4caf50" }} />
                      <Typography id="bd_typ_8" variant="subtitle2">
                        {t("Close")}
                      </Typography>
                    </IconButton>
                  </Grid>
                )}
                <Grid id="bd_grid_20" style={{ position: "relative", marginLeft: "15px" }}>
                  <Backdrop id="bd_backDrop" open={openSpeedDial} className={classes.backdrop} />
                  <SpeedDial
                    id="bd_speedDial"
                    ariaLabel="SpeedDial"
                    direction="up"
                    className={classes.speedDial}
                    icon={<SpeedDialIcon id="bd_sdIcon" />}
                    onClose={HandleCloseSpeedDial}
                    onOpen={() => HandleOpenSpeedDial(rows)}
                    open={openSpeedDial}
                  >
                    {actions.map((action) => (
                      <SpeedDialAction
                        id="bd_speedDialAction"
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        tooltipOpen={true}
                        classes={classTooltip}
                        onClick={action.action}
                      />
                    ))}
                  </SpeedDial>
                </Grid>
              </Grid>
            </Box>
          )}

          {breakdownDetailPopup === true ? (
            <Container id="bd_container_1">
              <Dialog id="bd_dialog" open={breakdownDetailPopup} onClose={HandleBreakdownDetailClose} fullWidth="xs">
                <DialogTitle id="bd_dialogT">{t("BreakdownDetail")}</DialogTitle>
                <DialogContent id="bd_dialogContent">
                  <form>
                    <FormControl id="bd_fromControl_3" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_2"
                        value={breakdownReasonGroupName}
                        onChange={(event, newValue) => {
                          HandleBreakdownReasonGroupFilter(newValue);
                        }}
                        options={breakdownReasonGroupDataFilter.map(
                          (option) => option.breakdownReasonGroupLocalizationName ?? option.name
                        )}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_5"
                            {...params}
                            margin="normal"
                            label={t("BreakdownGroup")}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                    <FormControl id="bd_fromControl_4" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_6"
                        defaultValue={""}
                        onChange={(event, newValue) => {
                          HandleBreakdownReasonPlace(newValue);
                        }}
                        value={selectedBreakdownReasonPlaceName}
                        options={breakdownReasonPlace.map(
                          (option) => option.breakdownReasonPlaceLocalizationName ?? option.name
                        )}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_9"
                            {...params}
                            margin="normal"
                            label={t("BreakdownPlace")}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                    <FormControl id="bd_fromControl_5" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_7"
                        defaultValue={""}
                        onChange={(event, newValue) => {
                          HandleBreakdownReasonDetail(newValue);
                        }}
                        value={selectedBreakdownReasonDetailName}
                        options={breakdownReasonDetail.map(
                          (option) => option.breakdownReasonDetailLocalizationName ?? option.name
                        )}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_10"
                            {...params}
                            margin="normal"
                            label={t("BreakdownDetail")}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                  </form>
                </DialogContent>
                <DialogActions id="bd_dialogAct">
                  <Button id="bd_button" onClick={HandleBreakdownDetailClose} color="primary">
                    {t("Close")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          ) : null}

          {unplannedMaintenanceReportPopup === true ? (
            <UnplannedMaintenaceOfTheReportsPopup
              handleOpen={unplannedMaintenanceReportPopup}
              handleClose={handleunplannedMaintenanceReportPopupClose}
              handleCancel={handleunplannedMaintenanceReportPopupCancel}
              startDate={startDate}
              minDate={rows.startDate}
              maxDate={rows.taskStatus === 5 ? rows.completedDate : moment().format("YYYY-MM-DDTHH:mm")}
              onStartDateChangeHandler={onStartDateChangeHandler}
              endDate={endDate}
              onEndDateChangeHandler={onEndDateChangeHandler}
              onNoteChangeHandler={onNoteChangeHandler}
              errorReports={errorReports}
              isReportsButtonDisable={isReportsButtonDisable}
              unplannedMaintenanceOfTheReport={UnplannedMaintenanceOfTheReport}
              deleteReportsButtonHandler={deleteReportsButtonHandler}
            />
          ) : null}

          {editRequestPopup === true ? (
            <Container id="bd_container_2">
              <Dialog id="bd_dialog_1" open={editRequestPopup} onClose={CancelEditRequest} fullWidth="xs">
                <DialogTitle id="bd_dialogT_1">{t("EditJobOrder")}</DialogTitle>
                <DialogContent id="bd_dialogContent_1">
                  <form>
                    <FormControl id="bd_fromControl_6" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_8"
                        defaultValue={rows != null ? rows.breakdownReasonGroupName : ""}
                        onChange={(event, newValue) => {
                          HandleBreakdownReasonGroupChange(newValue);
                        }}
                        options={breakdownReasonGroupData.map(
                          (option) => option.breakdownReasonGroupLocalizationName ?? option.name
                        )}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_11"
                            {...params}
                            margin="normal"
                            label={t("BreakdownGroup")}
                            variant="outlined"
                            error={error.breakdownReasonGroupText.length > 0}
                            helperText={error.breakdownReasonGroupText}
                          />
                        )}
                      />
                    </FormControl>
                    {rows.taskStatus !== 5 ? (
                      <FormControl id="bd_fromControl_7" variant="outlined" fullWidth>
                        <Autocomplete
                          id="bd_autoComplete_12"
                          defaultValue={rows != null ? rows.poolName : ""}
                          onChange={(event, newValue) => {
                            HandlePoolChange(newValue);
                          }}
                          options={poolData.map((option) => option.name)}
                          renderInput={(params) => (
                            <TextField
                              id="bd_textFiled_15"
                              {...params}
                              margin="normal"
                              label={t("Pool")}
                              variant="outlined"
                            />
                          )}
                        />
                      </FormControl>
                    ) : null}

                    <FormControl id="bd_fromControl_8" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_13"
                        defaultValue={rows != null ? rows.breakdownEffectName : ""}
                        onChange={(event, newValue) => {
                          HandleBreakdownEffectChange(newValue);
                        }}
                        options={breakdownEffectData.map(
                          (option) => option.breakdownEffectLocalizationName ?? option.name
                        )}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_16"
                            {...params}
                            margin="normal"
                            label={t("BreakdownEffect")}
                            variant="outlined"
                            error={error.breakdownEffectText.length > 0}
                            helperText={error.breakdownEffectText}
                          />
                        )}
                      />
                    </FormControl>

                    {rows.taskStatus !== 5 ? (
                      <FormControl id="bd_fromControl_9" variant="outlined" fullWidth disabled={disableEquipment}>
                        {rows.taskStatus != 6 ? (
                          <Autocomplete
                            id="bd_autoComplete_17"
                            defaultValue={rows != null ? rows.equipmentName : ""}
                            onChange={(event, newValue) => {
                              HandleEquipment(newValue);
                            }}
                            disabled={disableEquipment}
                            options={rows.taskStatus !== 6 ? equipmentInfo.map((option) => option.name) : []}
                            renderInput={(params) => (
                              <TextField
                                id="bd_textFiled_20"
                                {...params}
                                margin="normal"
                                label={t("Equipment")}
                                variant="outlined"
                                error={error.equipmentText.length > 0}
                                helperText={error.equipmentText}
                              />
                            )}
                          />
                        ) : (
                          <TextField
                            id="bd_textFiled_20"
                            margin="normal"
                            label={t("Equipment")}
                            variant="outlined"
                            value={rows.equipmentName}
                            disabled={true}
                          />
                        )}
                      </FormControl>
                    ) : null}
                  </form>
                </DialogContent>
                <DialogActions id="bd_dialogAct_1">
                  <Button id="bd_button_1" onClick={CancelEditRequest} color="secondary">
                    {t("Cancel")}
                  </Button>
                  <Button
                    id="bd_button_2"
                    onClick={() => UpdateTask(rows)}
                    color="primary"
                    disabled={isEditRequestButtonDisable}
                  >
                    {t("Confirm")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          ) : null}

          {assignPopup === true && rows.taskStatus !== 5 ? (
            <Container id="bd_container_3">
              <Dialog id="bd_dialog_2" open={assignPopup} onClose={CancelAssign} fullWidth="xs">
                <DialogTitle id="bd_dialogT_2">{t("AssigntoAnotherPerson")}</DialogTitle>
                <DialogContent id="bd_dialogContent_2">
                  <form>
                    <FormControl id="bd_fromControl_10" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_18"
                        defaultValue={""}
                        onChange={(event, newValue) => {
                          HandleUserChange(newValue);
                        }}
                        options={userData.map((option) => option.userName)}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_21"
                            {...params}
                            margin="normal"
                            label={t("Persons")}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                  </form>
                </DialogContent>
                <DialogActions id="bd_dialogAct_2">
                  <Button id="bd_button_3" onClick={CancelAssign} color="primary">
                    {t("Cancel")}
                  </Button>
                  <Button id="bd_button_4" onClick={() => AssignToSomeone(rows)} color="primary">
                    {t("Confirm")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          ) : null}

          {openAddFriendPopup === true && rows.taskStatus !== 5 ? (
            <Container id="bd_container_4">
              <Dialog id="bd_dialog_3" open={openAddFriendPopup} onClose={CloseAddFriendPopup} fullWidth="xs">
                <DialogTitle id="bd_dialogT_3">{t("AddFriend")}</DialogTitle>
                <DialogContent id="bd_dialogContent_3">
                  <form>
                    <FormControl id="bd_fromControl_11" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_19"
                        defaultValue={""}
                        onChange={(event, newValue) => {
                          HandleAddFriend(newValue);
                        }}
                        options={addFriendUserData.map((option) => option.userName)}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_22"
                            {...params}
                            margin="normal"
                            label={t("Persons")}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                  </form>
                </DialogContent>
                <DialogActions id="bd_dialogAct_3">
                  <Button id="bd_button_5" onClick={CloseAddFriendPopup} color="primary">
                    {t("Close")}
                  </Button>
                  <Button
                    id="bd_button_6"
                    disabled={addFriendUserData.length <= 0}
                    onClick={() => AddFriend(rows)}
                    color="primary"
                  >
                    {t("Add")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          ) : null}

          {openSubtaskPopup === true && rows.taskStatus !== 6 ? (
            <Container id="bd_container_5">
              <Dialog id="bd_dialog_4" open={openSubtaskPopup} onClose={CancelCreateSubtask} fullWidth="xs">
                <DialogTitle id="bd_dialogT_5">{t("CreateSubtask")}</DialogTitle>
                <DialogContent id="bd_dialogContent_4">
                  <form>
                    <FormControl id="bd_fromControl_12" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_20"
                        defaultValue={""}
                        onChange={(event, newValue) => {
                          HandleSubTaskPool(newValue);
                        }}
                        options={poolData.map((option) => option.name)}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_23"
                            {...params}
                            margin="normal"
                            label={t("Pool")}
                            variant="outlined"
                            error={errorSubTaskPoolText.length > 0 ? true : false}
                            helperText={errorSubTaskPoolText}
                          />
                        )}
                      />
                    </FormControl>
                    <FormControl id="bd_fromControl_13" variant="outlined" fullWidth>
                      <TextField
                        id="bd_textFiled_24"
                        multiline
                        label={t("MaintenanceNote")}
                        variant="outlined"
                        margin="normal"
                        onChange={(event) => setSubTaskNote(event.target.value)}
                        value={subTaskNote}
                      />
                    </FormControl>
                  </form>
                </DialogContent>
                <DialogActions id="bd_dialogAct_4">
                  <Button id="bd_button_7" onClick={CancelCreateSubtask} color="primary">
                    {t("Cancel")}
                  </Button>
                  <Button
                    id="bd_button_8"
                    onClick={() => CreateSubtask(rows)}
                    color="primary"
                    disabled={isCreateSubTaskButtonDisable}
                  >
                    {t("Confirm")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          ) : null}

          {pausePopup === true ? (
            <Container id="bd_container_6">
              <Dialog id="bd_dialog_5" open={pausePopup} onClose={ClosePausePopup} fullWidth="xs">
                <DialogTitle id="bd_dialogT_6">{t("Pause")}</DialogTitle>
                <DialogContent id="bd_dialogContent_5">
                  <form>
                    <FormControl id="bd_fromControl_14" variant="outlined" fullWidth>
                      <Autocomplete
                        id="bd_autoComplete_21"
                        defaultValue={""}
                        onChange={(event, newValue) => {
                          HandleMaintenancePauseReason(newValue);
                        }}
                        options={maintenancePauseReasonData.map((option) => option.name)}
                        renderInput={(params) => (
                          <TextField
                            id="bd_textFiled_25"
                            {...params}
                            margin="normal"
                            label={t("MaintenancePauseReason")}
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                    <TextField
                      id="bd_textFiled_26"
                      onChange={HandleMaintenancePauseNote}
                      label={t("PauseNote")}
                      variant="outlined"
                      multiline
                      fullWidth
                      margin="normal"
                    />
                  </form>
                </DialogContent>
                <DialogActions id="bd_dialogAct_5">
                  <Button id="bd_button_9" onClick={ClosePausePopup} color="primary">
                    {t("Cancel")}
                  </Button>
                  <Button id="bd_button_10" onClick={() => PauseTask(rows)} color="primary">
                    {t("Confirm")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          ) : null}

          {timelinePopup === true ? (
            <TimelinePopup
              id="bd_timelinePopup"
              array={timelineArray}
              open={timelinePopup}
              close={() => CloseTimelinePopup()}
            />
          ) : null}

          {documentPopup === true ? (
            <DocumentPopup
              id="bd_documentPopup"
              isMaintenanceDocuments={true}
              isEquipmentDocuments={true}
              list={documentList}
              equipmentDocuments={equipmentFiles}
              open={documentPopup}
              deleteFile={DeleteFile}
              deleteEquipmentFiles={DeleteEquipmentFile}
              close={() => CloseDocumentPopup()}
            />
          ) : null}

          {activeUsersTaskPopup === true ? (
            <Container id="bd_container_6">
              <Dialog id="bd_dialog_5" open={activeUsersTaskPopup} onClose={CloseActiveUsersTaskPopup} fullWidth="xs">
                <DialogTitle id="bd_dialogT_6">
                  {t("YouHaveUncompletedTasks", {
                    value: currentUsersActiveTaskId,
                  })}
                </DialogTitle>
                <DialogActions id="bd_dialogAct_5">
                  {!isUserAssignee ? (
                    <Button id="bd_button_10" onClick={RemoveTechnician} color="primary">
                      {t("LeaveTask")}
                    </Button>
                  ) : null}
                  <Button id="bd_button_9" onClick={GoToStartedTask} color="primary">
                    {t("GoToDetail")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          ) : null}

          {isFileUploaderPopupOpen ? (
            <FileUploaderPopup
              isOpen={isFileUploaderPopupOpen}
              onCancel={() => setIsFileUploaderPopupOpen(false)}
              onConfirm={UploadFiles}
            />
          ) : null}
        </Container>
      ) : null}
      <LoadingBackdrop id="bd_lbd" />
    </div>
  );
}
